module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10258.29058862.jpg";